import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ProcurementSideBar from '../../../../layouts/procurement/ProcurementSideBar';
import Logout from '../../../shared/auth/Logout';
import { API_URL } from '../../../../../utils/config';
import ProcurementLogo from '../../../../layouts/procurement/ProcurementLogo';
import AddRequestFeature from '../../../shared/features/AddRequestFeature';

export default class ProcurementFeature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
    };
  }

  componentDidMount() {
    this.getUserDetails();
  }

  getUserDetails() {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    };

    axios
      .get(`${API_URL}/employee/loggedOnEmployee`, config)
      .then((res) => {
        if (res.data) {
          this.setState({
            firstName: res.data.firstName,
          });
        }
      })
      .catch((err) => {});
  }

  render() {
    const { firstName } = this.state;

    return (
      <div className="main-wrapper">
        <header className="topbar shade bg-white fixed-top">
          <nav className="navbar navbar-expand-lg navbar-light top-navbar fixed-top">
            <ProcurementLogo />
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse mt-3" id="navbarText">
              <ul className="navbar-nav" style={{ marginRight: 'auto' }}>
                <li className="nav-item active">
                  <Link className="nav-link" to="#">
                    <h3>
                      Request a Feature<span className="sr-only">(current)</span>
                    </h3>
                  </Link>
                </li>
              </ul>
              <span className="navbar-text">
                <h4 className="admin">
                  {firstName}
                  <Logout />
                </h4>
              </span>
            </div>
          </nav>
        </header>

        <div className="all-sides col-lg-12 col-md-12 col-sm-12">
          <ProcurementSideBar />
          <div className="page-wrapper col-lg-10 col-md-10 col-sm-12">
            <AddRequestFeature />
          </div>
        </div>
      </div>
    );
  }
}
